// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../components/MDBox";
import MDTypography from "../../../../components/MDTypography";
import { HOME_URL } from "../../../../config/bases_url";
import { Form, Formik } from "formik";
import { NAME_ENTIDAD } from "../../../../helpers/regexs";
import { useRedirectForm } from "../../../../hooks/useRedirectForm";
import { useState } from "react";
import { useEditEntidadMutation } from "../../../../services";

// Settings page components
import FormField from "../../../../components/FormField";

import * as Yup from "yup";
import MDButton from "../../../../components/MDButton";
import MDImage from "../../../../components/MDImage/image";
import ComponentsPrivatization from "../../../../config/component_privatization";
import { COORDINADOR_DOCENTE } from "../../../../roles";
import no_foto from "../../../../assets/images/404.jpg";
import { useSnackbar } from "notistack";
import { getModifiedFields } from "helpers/functions";
import { handleToast } from "helpers/handleToast";
import { handleConfirmDialog } from "helpers/handleToast";

const style = {
  width: "100%",
  cursor: "pointer",
  borderRadius: "0.5rem",
  paddingRight: "0.5em",
  paddingLeft: "0.5em",
  maxWidth: "135px",
  minWidth: "135px",
  boxShadow: " 2px 2px 4px rgba(0, 0, 0, 0.2)",
  marginTop: "-100px",
  backgroundColor: "#6C6C6C",
};

function FormComponent({
  handleChange,
  handleBlur,
  values,
  errors,
  touched,
  editar,
}) {
  return (
    <MDBox mt={3}>
      <MDBox mb={1}>
        <FormField
          variant={"outlined"}
          name="nombre"
          label={"Nombre(s)"}
          onChange={handleChange}
          onBlur={handleBlur}
          type="text"
          value={values.nombre}
          error={errors.nombre && touched.nombre}
          success={values.nombre.length > 0 && !errors.nombre && editar}
          onInput={(e) =>
            (e.target.value = ("" + e.target.value).toUpperCase())
          }
        />
      </MDBox>
      <MDBox mb={1}>
        <FormField
          variant={"outlined"}
          name="localidad"
          label={"Localidad"}
          onChange={handleChange}
          onBlur={handleBlur}
          type="text"
          value={values.localidad}
          error={errors.localidad && touched.localidad}
          success={values.localidad.length > 0 && !errors.localidad && editar}
          onInput={(e) =>
            (e.target.value = ("" + e.target.value).toUpperCase())
          }
        />
      </MDBox>
      <MDBox mb={1}>
        <FormField
          variant={"outlined"}
          name="municipio"
          label={"Municipio"}
          onChange={handleChange}
          onBlur={handleBlur}
          type="text"
          value={values.municipio}
          error={errors.municipio && touched.municipio}
          success={values.municipio.length > 0 && !errors.municipio && editar}
          onInput={(e) =>
            (e.target.value = ("" + e.target.value).toUpperCase())
          }
        />
      </MDBox>
      <MDBox mb={1}>
        <FormField
          variant={"outlined"}
          name="clave_del_centro"
          label={"Clave"}
          onChange={handleChange}
          onBlur={handleBlur}
          type="text"
          value={values.clave_del_centro}
          error={errors.clave_del_centro && touched.clave_del_centro}
          success={
            values.clave_del_centro.length > 0 &&
            !errors.clave_del_centro &&
            editar
          }
          onInput={(e) =>
            (e.target.value = ("" + e.target.value).toUpperCase())
          }
        />
      </MDBox>
    </MDBox>
  );
}

function Content({ values }) {
  return (
    <MDBox mt={3}>
      <MDBox mb={2}>
        <MDTypography variant="button" fontWeight="bold">
          Nombre(s)
        </MDTypography>
        <MDTypography variant="body2" fontWeight="regular">
          {values.nombre}
        </MDTypography>
      </MDBox>

      <MDBox mb={2}>
        <MDTypography variant="button" fontWeight="bold">
          Localidad
        </MDTypography>
        <MDTypography variant="body2" fontWeight="regular">
          {values.localidad}
        </MDTypography>
      </MDBox>

      <MDBox mb={2}>
        <MDTypography variant="button" fontWeight="bold">
          Municipio
        </MDTypography>
        <MDTypography variant="body2" fontWeight="regular">
          {values.municipio}
        </MDTypography>
      </MDBox>

      <MDBox mb={2}>
        <MDTypography variant="button" fontWeight="bold">
          Clave
        </MDTypography>
        <MDTypography variant="body2" fontWeight="regular">
          {values.clave_del_centro}
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}
function EntidadInfo() {
  let authUser = JSON.parse(sessionStorage.getItem("user"));

  const initialValues = {
    nombre: authUser.perfil.entidad.nombre,
    logo: authUser.perfil.entidad.logo,
    municipio: authUser.perfil.entidad.municipio,
    localidad: authUser.perfil.entidad.localidad,
    clave_del_centro: authUser.perfil.entidad.clave_del_centro,
  };

  const [editar, setEditar] = useState(false);

  const [editEntidad, { isSuccess, isLoading, isError, error }] =
    useEditEntidadMutation();
  const { enqueueSnackbar } = useSnackbar();

  useRedirectForm(
    isLoading,
    isSuccess,
    isError,
    error,
    "Entidad editada",
    HOME_URL
  );

  const handleSubmit = async (values, actions) => {
    if (editar) {
      handleConfirmDialog({
        title: "¿Estás seguro que deseas modificar estos datos?",
        dispatcher: async (result) => {
          if (result.isConfirmed) {
            const modifiedFields = getModifiedFields(initialValues, values);
            if (Object.keys(modifiedFields).length !== 0) {
              await editEntidad({
                id: authUser.perfil.entidad.id,
                ...modifiedFields,
              });
              authUser.perfil.entidad = {
                ...authUser.perfil.entidad,
                ...modifiedFields,
              };
              sessionStorage.setItem("user", JSON.stringify(authUser));
            }
            actions.setSubmitting(false);
            setEditar(!editar);
          }
        },
      });
    } else {
      setEditar(!editar);
    }
  };

  return (
    <Card id="entidad-info" sx={{ overflow: "visible", marginTop: 13 }}>
      <Formik
        initialValues={initialValues}
        validationSchema={Yup.object({
          nombre: Yup.string()
            .required("El nombre es requerido.")
            .matches(
              NAME_ENTIDAD,
              "El nombre no puede contener caracteres extraños"
            ),
          municipio: Yup.string().required("El Municipio es requerido."),
          localidad: Yup.string().required("La localidad es requerida."),
          clave_del_centro: Yup.string().required(
            "La clave del centro es requerida."
          ),
        })}
        onSubmit={handleSubmit}
      >
        {({
          touched,
          values,
          errors,
          isValid,
          handleChange,
          handleBlur,
          setFieldValue,
          resetForm,
        }) => (
          <Form id={"change_entidad"} autoComplete="off">
            <MDBox pb={3} px={3}>
              <MDBox display="flex" justifyContent="space-between" mt={2}>
                <MDImage
                  id="logo-image"
                  htmlFor="logo-image"
                  disabled={!editar}
                  style={style}
                  src={
                    values.logo
                      ? typeof values.logo === "string"
                        ? values.logo
                        : URL.createObjectURL(values.logo)
                      : no_foto
                  }
                  handleChange={(e) => {
                    const file = e.target.files[0];
                    const maxSize = 1024 * 1024; // 250 KB

                    if (file.size > maxSize) {
                      enqueueSnackbar(
                        "El tamaño de la imagen no debe ser mayor a 1 MB",
                        {
                          variant: "error",
                          autoHideDuration: 4000,
                        }
                      );
                      return;
                    } else {
                      setFieldValue("logo", e.target.files[0]);
                    }
                  }}
                />
                <MDBox
                  display="flex"
                  flexDirection={"column"}
                  alignItems={"flex-end"}
                >
                  <MDTypography variant="h5" textTransform="uppercase">
                    Información
                  </MDTypography>
                  <MDTypography variant="h5" textTransform="uppercase">
                    de la Entidad
                  </MDTypography>
                </MDBox>
              </MDBox>
              {editar ? (
                <FormComponent
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  values={values}
                  errors={errors}
                  touched={touched}
                  editar={editar}
                />
              ) : (
                <Content values={values} />
              )}
              <ComponentsPrivatization permitted={[COORDINADOR_DOCENTE]}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  mt={3}
                  display="flex"
                  justifyContent={editar ? "space-between" : "flex-end"}
                >
                  {editar && (
                    <MDButton
                      onClick={(e) => {
                        const modifiedFields = getModifiedFields(
                          initialValues,
                          values
                        );
                        if (Object.keys(modifiedFields).length !== 0) {
                          handleConfirmDialog({
                            title: "¿Deseas descartar los cambios?",
                            dispatcher: (result) => {
                              if (result.isConfirmed) {
                                resetForm();
                                setEditar(false);
                              }
                            },
                          });
                        } else {
                          resetForm();
                          setEditar(false);
                        }
                      }}
                      variant="outlined"
                      color="accent"
                    >
                      cancelar
                    </MDButton>
                  )}
                  <MDButton
                    disabled={editar ? !isValid : false}
                    type="submit"
                    variant="contained"
                    color="accent"
                  >
                    {editar ? "guardar" : "editar"}
                  </MDButton>
                </Grid>
              </ComponentsPrivatization>
            </MDBox>
          </Form>
        )}
      </Formik>
    </Card>
  );
}

export default EntidadInfo;
